import React from 'react'
import PropTypes from 'prop-types'

import {HStack} from '@salesforce/retail-react-app/app/components/shared/ui'

import RightButton from './buttons/right'
import LeftButton from './buttons/left'

const ScrollerNavigationButtons = ({scroll}) => (
    <HStack gap="39px">
        <LeftButton onClick={() => scroll(-1)} />
        <RightButton onClick={() => scroll(1)} />
    </HStack>
)

ScrollerNavigationButtons.displayName = 'ScrollerNavigationButtons'

ScrollerNavigationButtons.propTypes = {
    scroll: PropTypes.func
}

export default ScrollerNavigationButtons
